module.exports = __webpack_public_path__ + "img/guandai_yj_kongdegang.9347f269.jpg";